import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { isEmpty, getIcon } from '../../Common/Common';

export default class Point_Settings extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.state = {
			scroll_top: 0,
		}

		this.devices_ref = React.createRef();
	}

	componentDidMount = () => {
		if (!isEmpty(this.props.param)) {
			if (this.props.param.devices_scroll_top != null) {
				this.devices_ref.current.scrollTop = this.props.param.devices_scroll_top;
			}
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleEditPoint = (point_id) => {
		this.props.content_handler('Edit_Point_Settings', { point_id: point_id, from: 'Point_Settings', devices_scroll_top: this.state.scroll_top });
	}

	handleOnScroll = () => {
		this.setState({
			scroll_top: this.devices_ref.current.scrollTop,
		})
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			cursor: 'pointer',
			width: this.props.width - 40,
			backgroundColor: 'white',
			marginTop: 10,
			marginBottom: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			padding: 5,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('point_settings')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div ref={this.devices_ref} onScroll={this.handleOnScroll} className='noScrollBar' style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto' }}>
						{Object.keys(window.app.state.point_list).map((point_id) => {
							let point_info = window.app.state.point_list[point_id];
							let icon = null;
							if (!isEmpty(point_info)) {
								icon = getIcon(point_info.icon);
								return (
									<div style={button_style} onClick={() => { this.handleEditPoint(point_id) }}>
										<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 5 }}>
											<img src={icon} style={{ width: 30 }} />
										</div>
										<div style={{ display: 'inline-block', width: '85%', verticalAlign: 'top', marginLeft: 10, paddingTop: 5, overflow: 'hidden' }}>
											<span style={{ whiteSpace: 'nowrap' }}>{point_info.name}</span>
										</div>
									</div>
								)
							}

						})}
					</div>
				</div>
			</div>
		)
	}
}